import styled from 'styled-components';

export const GroupWrapper = styled.div`

`;



// WEBPACK FOOTER //
// ./src/containers/VolleyCalendar/PoolTable/styles.js